/* ============================================================
   fc2-dealers - the "Where to try" map (2026-09-02).

   Markup and the dealer JSON are pre-rendered by sections/fc2-dealers.liquid.
   This file only adds the map: Google Maps JS with AdvancedMarkerElement
   markers drawing Ivo's pin from assets/fc-map-pin.js. Leaflet and the OSM
   tiles it pulled from unpkg are gone.

   MARKER CHOICE, the same reasoning as the cart's shipping hub: a classic
   Marker renders its icon as an IMAGE, where an SVG cannot always pull in
   external resources, so the shared builder would lose anything it references.
   An AdvancedMarkerElement renders real DOM, so the pin is the same markup
   the cart draws and the same CSS styles it. It requires a Map ID.

   COST, which Leaflet did not have: Maps JS is metered. The script is
   therefore requested only when the section actually reaches the viewport, so
   a visit that never scrolls down to the dealers costs nothing. One map load
   per page view at most, and no other request of any kind: the dealer
   coordinates are already in the page.

   FAILURE MODE: warn with '[fc2-dealers]' and hide the map box. The list is
   server rendered and carries every fact, so it is never affected.
   ============================================================ */
(function () {
  'use strict';

  /* Map ID of the falconclaw-storefront-maps project. It belongs to the
     project, not to a page, so the cart and this section share it. */
  var MAP_ID = '4d7fd2714dbbd29b58aa0d46';

  /* The pin the section has always used: brand green body, dark core. */
  var PIN_BODY = '#86c232';
  var PIN_DOT = '#0e1411';

  /* Leaflet fitted to at most zoom 11; Google's fitBounds has no such option,
     so it is clamped once the fit settles. */
  var MAX_FIT_ZOOM = 11;
  var FIT_PADDING = 40;
  var LOAD_MARGIN = '300px';

  var CB_NAME = 'fc2DealersMapsReady';

  function warn(what) {
    if (window.console) {
      console.warn('[fc2-dealers] map disabled, list still shown:', what);
    }
  }

  /* ---------------------------------------------------- maps bootstrap --- */

  /* One load per document, whoever asks first. Every waiter is answered
     either way: a caller that is never called back leaves its own loading
     latch set forever, which is exactly how a map dies silently. */
  var BOOT = { loading: false, ready: false, dead: false, waiters: [] };

  function drain(ok, why) {
    var queued = BOOT.waiters;
    BOOT.waiters = [];
    for (var i = 0; i < queued.length; i++) {
      try {
        if (ok) {
          queued[i].ok();
        } else if (queued[i].fail) {
          queued[i].fail(why);
        }
      } catch (err) {
        warn(err);
      }
    }
  }

  function loadMaps(key, ok, fail) {
    if (BOOT.dead) {
      fail('maps bootstrap already failed');
      return;
    }
    if (BOOT.ready) {
      ok();
      return;
    }
    BOOT.waiters.push({ ok: ok, fail: fail });
    if (BOOT.loading) {
      return;
    }
    /* something else on the page may already have brought Maps JS in */
    if (window.google && window.google.maps && window.google.maps.importLibrary) {
      BOOT.ready = true;
      drain(true);
      return;
    }
    BOOT.loading = true;

    function clearCb() {
      try {
        delete window[CB_NAME];
      } catch (err) {
        window[CB_NAME] = undefined;
      }
    }

    function died(why) {
      BOOT.dead = true;
      BOOT.loading = false;
      clearCb();
      drain(false, why);
    }

    /* With loading=async the bootstrap defines google.maps.importLibrary
       ASYNCHRONOUSLY, so the script tag's own onload runs before it exists.
       The callback parameter is the documented "the API is ready" signal, so
       that is what is used, with a watchdog in case it never fires. */
    window[CB_NAME] = function () {
      clearCb();
      BOOT.loading = false;
      if (!window.google || !window.google.maps || !window.google.maps.importLibrary) {
        died('maps ready but importLibrary missing');
        return;
      }
      BOOT.ready = true;
      drain(true);
    };

    window.setTimeout(function () {
      if (!BOOT.ready && !BOOT.dead) {
        died('maps did not become ready in time');
      }
    }, 15000);

    try {
      var s = document.createElement('script');
      s.async = true;
      s.src =
        'https://maps.googleapis.com/maps/api/js?key=' +
        encodeURIComponent(key) +
        '&loading=async&v=weekly&callback=' +
        CB_NAME;
      s.onerror = function () {
        died('maps script failed to load');
      };
      document.head.appendChild(s);
    } catch (err) {
      died(err);
    }
  }

  /* ------------------------------------------------------------- section - */

  function boot() {
    var mapEl = document.getElementById('fc2-deal-map');
    var dataEl = document.getElementById('fc2-deal-data');
    if (!mapEl || !dataEl || mapEl.dataset.fc2Init === '1') {
      return;
    }
    mapEl.dataset.fc2Init = '1';

    function hideMap() {
      try {
        mapEl.hidden = true;
      } catch (err) {
        /* the list is untouched either way */
      }
    }

    function fail(why) {
      hideMap();
      warn(why);
    }

    var dealers;
    try {
      dealers = JSON.parse(dataEl.textContent || '[]');
    } catch (err) {
      fail(err);
      return;
    }
    if (!dealers || !dealers.length) {
      hideMap();
      return;
    }

    /* A row and its point are matched by the index the Liquid stamped on the
       row, so a dealer without coordinates simply has no pin and still has
       its row. */
    var pts = [];
    for (var i = 0; i < dealers.length; i++) {
      var d = dealers[i];
      var lat = d ? parseFloat(d.lat) : NaN;
      var lng = d ? parseFloat(d.lng) : NaN;
      if (isNaN(lat) || isNaN(lng)) {
        continue;
      }
      pts.push({
        i: i,
        lat: lat,
        lng: lng,
        name: (d.name == null ? '' : String(d.name)),
        place: [d.city, d.country].filter(Boolean).join(', '),
        row: document.querySelector('.fc2-deal[data-fc2-deal-i="' + i + '"]'),
        marker: null,
        pin: null
      });
    }
    if (!pts.length) {
      hideMap();
      return;
    }

    var key = (mapEl.getAttribute('data-fc2-maps-key') || '').trim();
    if (!key) {
      fail('no maps key on the section');
      return;
    }
    if (!window.FCMapPin || !window.FCMapPin.html) {
      fail('fc-map-pin.js did not load');
      return;
    }

    var sel = -1;
    var hover = -1;
    var map = null;

    function pinMarkup(selected) {
      return window.FCMapPin.html({
        body: PIN_BODY,
        dot: PIN_DOT,
        selected: selected
      });
    }

    /* One pass over both lists, so a pin and its row can never disagree. */
    function paint() {
      for (var n = 0; n < pts.length; n++) {
        var p = pts[n];
        var isSel = p.i === sel;
        var isHov = p.i === hover;
        if (p.pin) {
          p.pin.classList.toggle('is-sel', isSel);
          p.pin.classList.toggle('is-hover', isHov && !isSel);
          p.pin.classList.toggle('is-dim', sel !== -1 && !isSel);
        }
        if (p.marker) {
          p.marker.zIndex = isSel ? 10 : (isHov ? 5 : 1);
        }
        if (p.row) {
          p.row.classList.toggle('is-active', isSel);
          p.row.classList.toggle('is-hover', isHov && !isSel);
        }
      }
    }

    function setHover(idx) {
      if (hover === idx) {
        return;
      }
      hover = idx;
      paint();
    }

    /* Clicking the one already chosen clears it, so every pin comes back to
       full strength without hunting for an empty patch of map. */
    function select(idx) {
      sel = sel === idx ? -1 : idx;
      paint();
      if (map && sel !== -1) {
        for (var n = 0; n < pts.length; n++) {
          if (pts[n].i === sel) {
            map.panTo({ lat: pts[n].lat, lng: pts[n].lng });
            break;
          }
        }
      }
    }

    function wireRow(p) {
      if (!p.row) {
        return;
      }
      p.row.addEventListener('mouseenter', function () {
        setHover(p.i);
      });
      p.row.addEventListener('mouseleave', function () {
        setHover(-1);
      });
      p.row.addEventListener('click', function (ev) {
        /* the Visit button is a link and stays one */
        if (ev.target && ev.target.closest && ev.target.closest('.fc2-deal__visit')) {
          return;
        }
        select(p.i);
      });
    }

    for (var w = 0; w < pts.length; w++) {
      wireRow(pts[w]);
    }

    function markerHost(p) {
      var host = document.createElement('div');
      host.className = 'fcmp-pinhost';
      host.innerHTML = pinMarkup(false);
      host.addEventListener('mouseenter', function () {
        setHover(p.i);
      });
      host.addEventListener('mouseleave', function () {
        setHover(-1);
      });
      return host;
    }

    function fit() {
      if (pts.length === 1) {
        map.setCenter({ lat: pts[0].lat, lng: pts[0].lng });
        map.setZoom(MAX_FIT_ZOOM);
        return;
      }
      var bounds = new window.google.maps.LatLngBounds();
      for (var n = 0; n < pts.length; n++) {
        bounds.extend({ lat: pts[n].lat, lng: pts[n].lng });
      }
      map.fitBounds(bounds, FIT_PADDING);
      /* fitBounds takes no maximum, so the first settled zoom is clamped and
         the listener is dropped: the customer's own zooming is theirs. */
      var once = map.addListener('idle', function () {
        if (once && once.remove) {
          once.remove();
        }
        if (map.getZoom() > MAX_FIT_ZOOM) {
          map.setZoom(MAX_FIT_ZOOM);
        }
      });
    }

    function build() {
      window.google.maps
        .importLibrary('maps')
        .then(function (lib) {
          return window.google.maps.importLibrary('marker').then(function (mk) {
            if (!lib || !lib.Map || !mk || !mk.AdvancedMarkerElement) {
              fail('maps or marker library incomplete');
              return;
            }
            map = new lib.Map(mapEl, {
              mapId: MAP_ID,
              center: { lat: pts[0].lat, lng: pts[0].lng },
              zoom: MAX_FIT_ZOOM,
              /* the page scrolls; a map that eats the wheel traps the reader */
              gestureHandling: 'cooperative',
              zoomControl: true,
              mapTypeControl: false,
              streetViewControl: false,
              fullscreenControl: false,
              clickableIcons: false
            });

            for (var n = 0; n < pts.length; n++) {
              (function (p) {
                var host = markerHost(p);
                p.marker = new mk.AdvancedMarkerElement({
                  map: map,
                  position: { lat: p.lat, lng: p.lng },
                  content: host,
                  title: p.place ? p.name + ', ' + p.place : p.name
                });
                p.pin = host.querySelector('.fcmp-pin');
                p.marker.addListener('click', function () {
                  select(p.i);
                });
              })(pts[n]);
            }

            fit();
            paint();
            mapEl.removeAttribute('aria-hidden');

            /* A box that was zero sized while the map was built lays out
               later; when it gains size, fit again so a suspended or
               offscreen section cannot leave an empty map. */
            try {
              if (window.ResizeObserver) {
                var seen = mapEl.offsetWidth > 0 && mapEl.offsetHeight > 0;
                var ro = new window.ResizeObserver(function () {
                  if (!seen && mapEl.offsetWidth > 0 && mapEl.offsetHeight > 0) {
                    seen = true;
                    fit();
                  }
                });
                ro.observe(mapEl);
              }
            } catch (err) {
              /* cosmetic only */
            }
          });
        })
        .catch(function (err) {
          fail(err);
        });
    }

    function start() {
      loadMaps(key, function () {
        try {
          build();
        } catch (err) {
          fail(err);
        }
      }, fail);
    }

    /* Nothing is requested until the section is nearly on screen. */
    try {
      if (window.IntersectionObserver) {
        var io = new window.IntersectionObserver(function (entries) {
          for (var n = 0; n < entries.length; n++) {
            if (entries[n].isIntersecting) {
              io.disconnect();
              start();
              return;
            }
          }
        }, { rootMargin: LOAD_MARGIN });
        io.observe(mapEl);
      } else {
        start();
      }
    } catch (err) {
      start();
    }
  }

  window.FC2Dealers = { init: boot };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* the theme editor re-inserts a section without reloading the document */
  document.addEventListener('shopify:section:load', boot);
})();
